"use client";
import React from "react";
import Button from "../Button";
import Flex from "../Flex";
import Text from "../Text";
import Tooltip from "../Tooltip";
import styled from "styled-components";
import { getBorderRadius } from "../utils";

export type SelectorOption = {
  value: string;
  iconId: string;
  label?: string;
  tooltip?: string;
};

type Props = {
  options: SelectorOption[];
  value: string;
  onChange: (value: string) => void;
  flex?: number | string;
};

const Container = styled(Flex).attrs(props => {
  return {
    border: "default",
    p: "1px",
    // borderRadius: "6px",
    gap: "1px",
    backgroundColor: "white",
    borderRadius: getBorderRadius("defaultOuter", null, props),
  };
})``;

const Selector: React.FC<Props> = ({ options, value, onChange, flex }) => {
  const hasLabels = options.some(opt => opt.label);
  return (
    <Flex flexDirection="column" flex={flex}>
      <Container>
        {options.map(opt => {
          const active = opt.value === value,
            tooltipSource = opt.tooltip ? `selector-${opt.value}-tooltip` : undefined;
          return (
            <React.Fragment key={opt.value}>
              {opt.tooltip && (
                <Tooltip direction="top" source={tooltipSource} interactive={false}>
                  {opt.tooltip}
                </Tooltip>
              )}
              <Button
                size="small"
                buttonStyle="primary"
                icon={opt.iconId}
                flex={1}
                data-tooltip-source={tooltipSource}
                themeOverrides={{
                  primaryColor: active ? "grayLight" : "white",
                  primaryColorDark: "gray",
                  primaryColorTint: "black",
                }}
                onClick={() => onChange(opt.value)}
              />
            </React.Fragment>
          );
        })}
      </Container>
      {hasLabels && (
        <Flex mt="2px">
          {options.map(opt => (
            <Text key={opt.value} textAlign="center" flex={1} font="ui.extraTiny" color="grayDark">
              {opt.label ?? ""}
            </Text>
          ))}
        </Flex>
      )}
    </Flex>
  );
};

export default Selector;
